if (!customElements.get('subscription-variant-radios')) {
  customElements.define('subscription-variant-radios', class SubscriptionVariantRadios extends HTMLElement {
    constructor() {
      super();
      const form = this.closest('form');
      this.inputID = form.querySelector('[name=id]');
      this.radios = this.querySelectorAll('[name^="variant"]');
      this.moneyContainer = form.querySelector('.money');

      this.radios.forEach((radio) => {
        radio.addEventListener('click', this.onChangeHandler.bind(this));
      });
    }


    onChangeHandler(evt) {
      const variantId = evt.target.value;
      this.inputID.value = variantId;
      this.moneyContainer.innerHTML = evt.target.dataset.variantPrice;
    }

  });
}

if (!customElements.get('delivery-plan-groups')) {
  customElements.define('delivery-plan-groups', class deliveryPlanGroups extends HTMLElement {
    constructor() {
      super();
      const form = this.closest('form');
      this.sellingPlan = form.querySelector('[name=selling_plan]');
      this.deliveryPlan = form.querySelector('select[name="deliery_plan"]');

      this.deliveryPlan.addEventListener('change', this.onChangeHandler.bind(this));

    }


    onChangeHandler(evt) {
      const planID = evt.target.value;
      this.sellingPlan.value = planID;
    }

  });
}
